// import external dependencies
import 'jquery';
import '@fancyapps/fancybox/dist/jquery.fancybox.min.js';
import 'slick-carousel/slick/slick.min';

// Import everything from autoload


// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

//////////// Testimonial

if ($('.js-carousel-testimonial').length) {
  $('.js-carousel-testimonial').slick({
    accessibility: true,
    adaptiveHeight: true,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    fade: true,
    pauseOnFocus: false,
    pauseOnHover: false,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
  });
}

//////////// Testimonial

if ($('.js-carousel-gallery').length) {
  $('.js-carousel-gallery').slick({
    accessibility: true,
    adaptiveHeight: true,
    autoplay: true,
    autoplaySpeed: 7000,
    arrows: false,
    fade: true,
    pauseOnFocus: false,
    pauseOnHover: false,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
  });
}



// WEBPACK FOOTER //
// ./scripts/main.js